import FeatureTabsLayout from '@/shared/components/FeatureTabsLayout/FeatureTabsLayout'

export default function AppearanceLayout() {
  return (
    <FeatureTabsLayout
      breadcrumbs={['Admin', 'Platform Configuration', 'Appearance', 'Branding']}
      basePath="/appearance"
      tabs={[
        { segment: 'branding', label: 'Branding' },
        { segment: 'login-screen-setup', label: 'Login Screen Setup' },
        { segment: 'navigation-builder', label: 'Navigation Builder' },
      ]}
      shouldShowTabs={(pathname) =>
        /\/appearance\/(branding|login-screen-setup|navigation-builder)$/.test(
          pathname
        )
      }
      getActiveSegment={(pathname) => {
        const seg =
          pathname.split('/appearance/')[1]?.split('/')[0] ?? ''
        if (seg) return seg
        return 'branding'
      }}
    />
  )
}
